import { c } from 'react-compiler-runtime';
import { clsx } from 'clsx';
import classes from './Popover.module.css.js';
import React from 'react';
import { jsx } from 'react/jsx-runtime';

const Popover = /*#__PURE__*/React.forwardRef(function Popover(t0, forwardRef) {
  const $ = c(15);
  let className;
  let open;
  let props;
  let relative;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      caret: t1,
      open,
      relative,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = open;
    $[3] = props;
    $[4] = relative;
    $[5] = t1;
  } else {
    className = $[1];
    open = $[2];
    props = $[3];
    relative = $[4];
    t1 = $[5];
  }
  const caret = t1 === undefined ? "top" : t1;
  const t2 = open ? "" : undefined;
  const t3 = relative ? "" : undefined;
  let t4;
  if ($[6] !== className) {
    t4 = clsx(className, classes.Popover);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== caret || $[9] !== forwardRef || $[10] !== props || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = /*#__PURE__*/jsx("div", {
      ...props,
      ref: forwardRef,
      "data-open": t2,
      "data-relative": t3,
      "data-caret": caret,
      className: t4
    });
    $[8] = caret;
    $[9] = forwardRef;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
});
Popover.displayName = 'Popover';
const PopoverContent = t0 => {
  const $ = c(12);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      width: t1,
      height: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const width = t1 === undefined ? "small" : t1;
  const height = t2 === undefined ? "fit-content" : t2;
  let t3;
  if ($[5] !== className) {
    t3 = clsx(className, classes.PopoverContent);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== height || $[8] !== props || $[9] !== t3 || $[10] !== width) {
    t4 = /*#__PURE__*/jsx("div", {
      "data-width": width,
      "data-height": height,
      className: t3,
      ...props
    });
    $[7] = height;
    $[8] = props;
    $[9] = t3;
    $[10] = width;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
PopoverContent.displayName = 'Popover.Content';
var Popover$1 = Object.assign(Popover, {
  Content: PopoverContent
});

export { Popover$1 as default };
